import { Component, inject } from '@angular/core';
import { BasicForm } from '@shared/components/classes/basic.form';
import { DefaultService } from '@common/references/default.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { PasswordModule } from '@primeng/password';
import { InputNumberModule } from '@primeng/inputnumber';
import { CalendarModule } from '@primeng/calendar';
import { DropdownModule } from '@primeng/dropdown';
import { MultiSelectModule } from '@primeng/multiselect';
import { CheckboxModule } from '@primeng/checkbox';
import { RadioButtonModule } from '@primeng/radiobutton';
import { SliderModule } from '@primeng/slider';
import { InputSwitchModule } from '@primeng/inputswitch';
import { InputTextareaModule } from '@primeng/inputtextarea';
import { ColorPickerModule } from '@primeng/colorpicker';
import { ChipsModule } from '@primeng/chips';
import { InputMaskModule } from '@primeng/inputmask';
import { FloatLabelModule } from '@primeng/floatlabel';
import { ToggleButtonModule } from "@primeng/togglebutton";
import { ResidentsService } from '@modules/universal-billing/residents/residents.service';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { JsonPipe } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { RentType } from '@modules/universal-billing/residents/resident.enum';
import { ApartmentPipe } from '@common/pipe/apartment.pipe';
import { FieldsetComponent } from '@shared/components/fieldset/fieldset.component';
import urlJoin from 'url-join';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-resident-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputValidatorDirective,
    PasswordModule,
    InputNumberModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    CheckboxModule,
    RadioButtonModule,
    SliderModule,
    InputSwitchModule,
    InputTextareaModule,
    ColorPickerModule,
    ChipsModule,
    InputMaskModule,
    FloatLabelModule,
    ToggleButtonModule,
    AutocompleteComponent,
    JsonPipe,
    TranslatePipe,
    NgSelectComponent,
    ApartmentPipe,
    FieldsetComponent
  ],
  templateUrl: './resident-form.component.html',
  styleUrl: './resident-form.component.scss',
})
export class ResidentFormComponent extends BasicForm<any> {
  _defaultService: DefaultService<any> = inject(ResidentsService);
  form: FormGroup;
  _http = inject(HttpClient);

  rentTypes: any;
  public translate = inject(TranslateService);
  dateFields = ['birthDate', 'bankAccountValid'];

  constructor(private fb: FormBuilder) {
    super();
    this.form = this.fb.group({
      code: [null, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      middleName: [null],
      birthDate: [null, Validators.required],
      idCardNumber: [null, Validators.required],
      socialStatus: [null,Validators.required],
      taxCode: [null],
      bankAccount: [null],
      bankCode: [null],
      rentType: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phoneNumber: [null,Validators.required],
      status: [true, Validators.required],
    });

    this.rentTypes = [RentType.ROOM, RentType.BUILDING, RentType.APARTMENT].map(item => ({
      id: item,
      name: this.translate.instant(`RENT_TYPES.${item}`)
    }));
  }

  ngOnInit() {
    super.ngOnInit();
    this.getData();
  }

  getData(): any {
    this._http.get<any>(urlJoin(environment.apiUrl, 'residents/generate-account-number')).subscribe(data => {
      this.form.get('code')?.setValue(data.data.nextCode);
    });
  }

}
